import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PostInspectionDiyPickupRtoDocuments from "./component";
import { getPickupDocuments, setActiveTab } from "../post-inspection-diy/actions";

const mapStateToProps = ({
    postInspectionDiy: {
        doctet
    }
}) => ({
    doctet
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getPickupDocumentsConnect: getPickupDocuments,
    setActiveTabConnect: setActiveTab
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PostInspectionDiyPickupRtoDocuments);
